import { useAuth0 } from '@auth0/auth0-react';
import { useGateValue } from '@statsig/react-bindings';
import { ENV_CONFIG } from 'config/environment';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { useEffect, useState } from 'react';
import { getUserData } from 'selectors/user';
import { setSiteAccessToken, setUserName } from 'services/storage';
import { loginUser } from 'store/user/actions';

// Re-mints tokens (bypassing SDK cache) and retries once to get the namespaced email claim. Remove after tokens have refreshed
const STALE_TOKEN_REFRESH_GATE = 'site_login_stale_token_refresh';

export const useAuth = (onAuth?: () => any) => {
  const dispatch = useAppDispatch();
  const [auth0Requested, setAuth0Requested] = useState(false);
  const { user, getAccessTokenSilently } = useAuth0();
  const userData = useAppSelector(getUserData);
  const staleTokenRefreshEnabled = useGateValue(STALE_TOKEN_REFRESH_GATE);

  useEffect(() => {
    if (userData) {
      setUserName(userData.first_name);
    }
  }, [userData]);

  useEffect(() => {
    const authParams = {
      audience: `https://${ENV_CONFIG().AUTH.DOMAIN}/api/v2/`,
      scope: 'read:current_user',
    };

    const getUserMetadata = async () => {
      if (user?.sub) {
        try {
          let accessToken = await getAccessTokenSilently({
            authorizationParams: authParams,
          });
          setSiteAccessToken(accessToken);

          let ok = accessToken ? await dispatch(loginUser(accessToken)) : false;

          if (!ok && staleTokenRefreshEnabled) {
            accessToken = await getAccessTokenSilently({
              cacheMode: 'off',
              authorizationParams: authParams,
            });
            setSiteAccessToken(accessToken);
            ok = accessToken ? await dispatch(loginUser(accessToken)) : false;
          }

          if (ok && onAuth) {
            await onAuth();
          }
          setAuth0Requested(true);
        } catch (e) {
          console.warn(e);
        }
      }
    };

    if (!auth0Requested) {
      getUserMetadata();
    }
  }, [user?.sub]);

  return auth0Requested;
};
